import { Page } from "./styles";

const Component = ({ children }) => {
  return <Page>{children}</Page>;
};

export default Component;
